import { useLoadableSlice } from "../../store/shared/withLoadingState";
import { loadLists } from "../../store/lists/lists.actions";
import { getListsSliceByProfileId } from "../../store/lists/lists.selectors";

export const useLists = (profileId) =>
  useLoadableSlice(loadLists(profileId), getListsSliceByProfileId(profileId));
